export abstract class DSLBase {
  abstract raw(): any;
}
